module.exports = __webpack_public_path__ + "img/product-atomizer-kangertech-Protank_Bar.4c8437e2.jpg";